import { BaseURL, httpClient } from './base/httpClient';
import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { getAuthorization, setAuthorization } from "../services/authorizationGateway";

export async function IsValidKey(key) {
    var apiResponse = await httpClient.get(BaseURL + "/selfie/validate-token",
        {
            headers: {
                "token": key,
                "deviceKey": Config.DeviceKeyIdentifier,
                "userAgent": FaceTecSDK.createFaceTecAPIUserAgentString("")
            }
        });
        
    if (apiResponse.success) localStorage.setItem("f_", JSON.stringify(apiResponse));
    return apiResponse.success;
}